<template>
	<div>
		<div class="judianList">
			<ul>
				<div>
				<!-- <router-link :to=goToUrl> -->
					<li v-for="(item,index) in pointData" class="oneCell" :class="index%3 === 0?'cell01':(index%3===1?'cell02':'cell03')" @click="gotoIndex(item)">
						<div class="cellImg">
							<div class="imgCirBg">
								<img :src="item.pointImgSrc" />
								<!--<img src="../../assets/images/beijing.jpg" />-->
							</div>
						</div>
						<div>{{item.pointName}}</div>
						<!--<div class="ckeJu juIsCked"></div>-->
						<div class="juMark">{{item.pointName}}</div>
					</li>
				</div>
				<!-- </router-link> -->
		    </ul>
		</div>
		    
	</div>
</template>

<script>
	import {_api} from '@/service/interface'
	export default {
        name: "WcPoint",
        data() {
        	return {
				goToUrl:'/index',
        		pointData:[
        			/*{"pointName":"北京大学","pointImgSrc":require('../../assets/images/fudan.jpg')},
        			{"pointName":"清华大学","pointImgSrc":require('../../assets/images/qinghua.jpg')},
        			{"pointName":"复旦大学","pointImgSrc":require('../../assets/images/beijing.jpg')},
        			{"pointName":"郑州大学","pointImgSrc":require('../../assets/images/fudan.jpg')},
        			{"pointName":"湖南大学","pointImgSrc":require('../../assets/images/qinghua.jpg')},
        			{"pointName":"复旦大学","pointImgSrc":require('../../assets/images/fudan.jpg')},
        			{"pointName":"郑州大学","pointImgSrc":require('../../assets/images/qinghua.jpg')},
        			{"pointName":"湖南大学","pointImgSrc":require('../../assets/images/beijing.jpg')},
        			{"pointName":"复旦大学","pointImgSrc":require('../../assets/images/fudan.jpg')},
        			{"pointName":"郑州大学","pointImgSrc":require('../../assets/images/beijing.jpg')},
        			{"pointName":"湖南大学","pointImgSrc":require('../../assets/images/qinghua.jpg')}*/
        		],
        		isCell01:true,
        		isCell02:true,
        		isCell03:true
        		
			}
        },
        mounted(){
        	this.getPointList()
        },
        computed:{
        	computedCellStyle(){
        		var pointLen = this.pointData.length;
        		for(var i=0;i<pointLen;i++){
        			console.log(i%3);
        			if(i%3==0){
        				return {
		    				cell01:this.isCell01,
		    				cell02:!this.isCell02,
		    				cell03:!this.isCell03
		    			}
        			}else if(i%3==1){
        				return {
		    				cell01:!this.isCell01,
		    				cell02:this.isCell02,
		    				cell03:!this.isCell03
		    			}
        			}
        		}
    			
        		
        	}
        },
        beforeUpdate() {
		    // 避免初始化之前产生事件
		},
		methods:{
			gotoIndex(item){
				localStorage.setItem("point",item.pointName);
				if(sessionStorage.getItem("termType")=="channel"){
					
				}else{
					sessionStorage.setItem("imgUrl",item.pointImgSrc)
					this.selectPoint(item);
				}
			},
			
			getPointList(){
				_api('_point','[0].code',{params:{mark:'agentList'}},data=>{
					this.pointData=[];
					let type=sessionStorage.getItem("termType")=="channel"?"channel":"agent"
					data[0].data.agentList.forEach(item=>{
						this.pointData.push({
							pointId:item[type+"Id"],
							pointName:item[type+"Name"],
							pointImgSrc:data[1].url+item[type+"Img"]
						})
					})
				},err=>{
					
				})
			},
			
			selectPoint(item){
				let data={'mark':'','agentId':item.pointId,'cdevceType':'','cdevceid':'','agentName':item.pointName};
				_api('_point','.code',{params:data},res=>{
					this.$router.push(this.goToUrl)
				},err=>{
					
				})
			}
		}
    }
</script>

<style>
	.judianList{
		width: 90%;
		margin: 10px auto;
		padding-top: 10px;
	}
	.oneCell{
		width: 100%;
		height: 100px;
		border-radius: 15px;
		background: gold;
		margin-bottom: 15px;
		margin-top: 5px;
		display: flex;
	    align-items: center;
	    font-size: 16px;
	    color: #FFFFFF;
	    position: relative;
	}
	.cell01{
		background-image: linear-gradient(left,#04B7CB,#029ECE);
		background-image: -webkit-linear-gradient(left,#04B7CB,#029ECE);
	}
	.cell02{
		background-image: linear-gradient(left,#00C3BF,#03AFC7);
		background-image: -webkit-linear-gradient(left,#00C3BF,#03AFC7);
	}
	.cell03{
		background-image: linear-gradient(left,#02C6BC,#16CD97);
		background-image: -webkit-linear-gradient(left,#02C6BC,#16CD97);
	}
	.cellImg{
		width: 120px;
		height: 100px;
		display: flex;
		justify-content: center;
		align-items: center;
	}
	.imgCirBg{
		width: 80px;
		height: 80px;
		background: #FFFFFF;
		border-radius: 80px;
		display: flex;
		justify-content: center;
		align-items: center;
	}
	.imgCirBg>img{
		width: 75px;
		height: 75px;
		border-radius: 75px;
		background-size: 75px 75px;
	}
	/*.ckeJu{
		width: 20px;
		height: 20px;
		border-radius: 20px;
		background: gold;
		position: absolute;
		top: 10px;
		right: 10px;
	}*/
	.juIsCked{
		background: greenyellow;
	}
	.juMark{
		height: 60px;
	    position: absolute;
	    bottom: -10px;
	    right: -10px;
	    font-size: 50px;
	    text-align: right;
	    color: #EFEFF4;
	    opacity: .2;
	}
</style>


// WEBPACK FOOTER //
// src/components/judianPoint/WcPoint.vue